module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Myths&Monsters.3cda5ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Myths&Monsters.jpg
// module id = CXlV
// module chunks = 0